import React from 'react';

import cx from 'classnames';

import Icon from 'components/shared/Icon';
import Triangle from 'components/shared/Icon/icons/Triangle';

import styles from './index.module.css';

function PopupActionButtons({ onPrevPage, onNextPage, isNextSubmitType }) {
  return (
    <div className={styles.container}>
      {onPrevPage && (
        <button type="button" onClick={onPrevPage} className={cx('buttonReset', styles.button, styles.buttonBack)}>
          <Icon component={Triangle} className={styles.arrowIcon} />
          <div className={styles.label}>Back</div>
        </button>
      )}

      {(isNextSubmitType || onNextPage) && (
        <button
          type={isNextSubmitType ? 'submit' : 'button'}
          onClick={onNextPage}
          className={cx('buttonReset', styles.button, styles.buttonNext)}
        >
          <div className={styles.label}>Next</div>
          <Icon component={Triangle} className={styles.arrowIcon} />
        </button>
      )}
    </div>
  );
}

export default PopupActionButtons;
